import { Op, OrderBy } from './client';

export function versionStatus(versionStatus) {
	return [
		Op.equalTo('sys.versionStatus', versionStatus)
	];
}

export function includeInSearch() {
	return [
		Op.or(
			Op.and(
				Op.exists('sys.metadata.includeInSearch', true), 
				Op.equalTo('sys.metadata.includeInSearch', true)
				),
			Op.exists('sys.metadata.includeInSearch', false)
		)
	];
}

export function cswipContentType() {
	return [
		Op.or(
			Op.and(
				Op.equalTo('sys.contentTypeId', 'cswipPageTemplateWebpage'),
				Op.equalTo('sys.metadata.includeInSearch', true),
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'pressReleases'),
				Op.contains('whichWebsiteToDisplayOn', 'CSWIP')
			),
			Op.equalTo('sys.contentTypeId', 'cswipSchemes'),
			Op.and(
				Op.or(
					Op.equalTo('sys.contentTypeId', 'pdf'),
					Op.equalTo('sys.contentTypeId', 'word'),
					Op.equalTo('sys.contentTypeId', 'excel')
				),
				Op.contains('sys.uri', '/microsites/cswip/')
			)
			)
	];
}

export function twiinContentType() {
	return [
		Op.or(
			Op.and(
				Op.equalTo('sys.contentTypeId', 'twiInnovationNetworkPageTemplateWebpage'),
				Op.equalTo('sys.metadata.includeInSearch', true),
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'pressReleases'),
				Op.contains('whichWebsiteToDisplayOn', 'TWIInnovationNetwork')
			),
			Op.and(
				Op.or(
					Op.equalTo('sys.contentTypeId', 'pdf'),
					Op.equalTo('sys.contentTypeId', 'word'),
					Op.equalTo('sys.contentTypeId', 'excel')
				),
				Op.contains('sys.uri', '/innovation-network/')
			)
			)
	];
}

export function genericSearchContentType(settings) {
	return [
		Op.or(
			Op.and(
				Op.or(
					Op.equalTo('sys.dataFormat', 'webpage'),
					Op.equalTo('sys.contentTypeId', 'pdf')
				),
				Op.startsWith('sys.uri', settings.baseUri),
				Op.equalTo('sys.metadata.includeInSearch', 'true'),
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'pressReleases'),
				Op.contains('whichWebsiteToDisplayOn', settings.microsite)
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'events'),
				Op.contains('whichWebsiteToDisplayOn', settings.microsite)
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'insights'),
				Op.contains('whichWebsiteToDisplayOn', settings.microsite)	
			),

		)

	];
}


export function contentType(contentTypeId) {
	if(contentTypeId){
		if(contentTypeId === 'search'){
			//console.log("SEARCH - 21");
			return [
				Op.or(
					Op.equalTo('sys.dataFormat', 'webpage').weight(5000),
					Op.equalTo('sys.contentTypeId', 'pressReleases').weight(5000),
					Op.equalTo('sys.contentTypeId', 'publishedPapers').weight(5000),
					Op.equalTo('sys.contentTypeId', 'events').weight(5000),
					Op.equalTo('sys.contentTypeId', 'insights').weight(5000),
					// Op.equalTo('sys.contentTypeId', 'staffProfiles').weight(5000),
					Op.equalTo('sys.contentTypeId', 'pdf').weight(5000),
					Op.equalTo('sys.contentTypeId', 'word').weight(5000),
					Op.equalTo('sys.contentTypeId', 'excel').weight(5000),
					//TWI Research, TWI Knowledge, Non-TWI research, Non-TWI knowledge
					Op.in('sys.metadata.contentCategory', ...['0/403/440','0/403/439','0/403/409','0/403/408']),
					Op.and(
						Op.equalTo('sys.contentTypeId', 'weldasearch').weight(500),
						Op.in('contentType', ...['0/403/440','0/403/439','0/403/409','0/403/408'])
						)
					)
			];
		}

		else if(contentTypeId === 'pressReleases'){
			return [
				Op.or(
					Op.and(
						Op.equalTo('sys.dataFormat', 'webpage').weight(5000),
						Op.in('sys.metadata.categories', '0/56/64')
					),
				Op.equalTo('sys.contentTypeId', 'pressReleases').weight(5000),
				)
			];
		}
		else if(contentTypeId === 'events'){
			return [
				// Op.and(
					Op.equalTo('sys.contentTypeId', 'events').weight(5000),
					// Op.in('eventType', ...['0/44/45/47/50','0/44/45/47/48','0/44/45/47/49'])
				// )
			];
		}
		else if(contentTypeId === 'publishedPapers'){
			return [
					Op.or(
						Op.equalTo('sys.contentTypeId', 'publishedPapers'),
						Op.startsWith('sys.uri', '/technical-knowledge/published-papers/')
						)					
			];
		}
		// else if(contentTypeId === 'faqs'){
		// 	return [

		// 			Op.or(
		// 				Op.and(
		// 					searchCurrentDir(),
		// 					excludeHomePage()
		// 					),

		// 				Op.and(
		// 					Op.in('sys.contentTypeId', 'faqs'),
		// 					Op.contains('whichWebsiteToDisplayOn.list', 'TWIMiddleEast')
		// 					)
		// 				),

										
		// 	];
		// }


		else if(Array.isArray(contentTypeId)){
			return [
				Op.in('sys.contentTypeId', ...contentTypeId)
			];
		}else{
			return [
				Op.equalTo('sys.contentTypeId', contentTypeId)
			];
		}
	}
	return [];
}

export function searchTerm(term) {
	if (term) {
		return [Op.freeText('title', term)];
	}
	return [];
}

export function weightedSearchTerm(term, weightedFields) {
	if (term) {
		return [Op.or().addRange(			
			Object.keys(weightedFields).map((index) => (Op.freeText(weightedFields[index].fieldName, term, true, "and").weight(weightedFields[index].weight)))
		)];		
	}
	return [];
}

export function containsSearch(term, weightedFields) {
	if (term) {
		return [Op.or().addRange(			
			Object.keys(weightedFields).map((index) => (Op.contains(weightedFields[index].fieldName, term).weight(weightedFields[index].weight)))
		)];		
	}
	return [];
}



export function authorSearch(search){
	if(search.searchType && search.author && search.searchType == 'technical'){
		return [
			Op.or(
				Op.freeText('author', search.author).weight(1000),
				Op.freeText('sys.metadata.author', search.author).weight(1000),
				Op.contains('author', search.author).weight(1000),
				Op.contains('sys.metadata.author', search.author).weight(1000)
			)
		];
	}
	return [];
}

export function searchAll() {
    var ret =
        [
            Op.or(
                Op.equalTo('sys.dataFormat', 'webpage'),
                Op.equalTo('sys.contentTypeId', 'weldasearch'),
                Op.equalTo('sys.contentTypeId', 'pressReleases'),
				Op.equalTo('sys.contentTypeId', 'publishedPapers'),
				Op.equalTo('sys.contentTypeId', 'publicFundedProjects'),
				Op.equalTo('sys.contentTypeId', 'ourStories'),
                Op.equalTo('sys.contentTypeId', 'events'),
                Op.equalTo('sys.contentTypeId', 'insights'),
                Op.equalTo('sys.contentTypeId', 'pdf'),
                Op.equalTo('sys.contentTypeId', 'word'),
                Op.equalTo('sys.contentTypeId', 'excel'),
                //TWI Research, TWI Knowledge, Non-TWI research, Non-TWI knowledge
				Op.in('sys.metadata.contentCategory', ('0/403/440', '0/403/439', '0/403/409', '0/403/408')),
			)
        ];
	return ret;
}

export function searchWeldasearch(search)
{
    if (!search.weldasearch || search.weldasearch == "false") {
        return [Op.not(Op.equalTo('sys.contentTypeId', 'weldasearch'))];
    }
    return [];
}
export function searchTabTypes(search) {
    if (search.searchType) {
        if (search.searchType === 'search') {
			//console.log("SEARCH - 114");
            return [
                Op.or(
						Op.equalTo('sys.dataFormat', 'webpage').weight(5000),
						Op.equalTo('sys.contentTypeId', 'pressReleases').weight(5000),
						Op.equalTo('sys.contentTypeId', 'publishedPapers').weight(5000),
						Op.equalTo('sys.contentTypeId', 'events').weight(5000),
						Op.equalTo('sys.contentTypeId', 'insights').weight(5000),
						// Op.equalTo('sys.contentTypeId', 'staffProfiles').weight(5000),
						Op.equalTo('sys.contentTypeId', 'pdf').weight(5000),
						Op.equalTo('sys.contentTypeId', 'word').weight(4000),
						Op.equalTo('sys.contentTypeId', 'excel').weight(1000),
						//TWI Research, TWI Knowledge, Non-TWI research, Non-TWI knowledge
						Op.in('sys.metadata.contentCategory', ...['0/403/440','0/403/439','0/403/409','0/403/408']),
						Op.and(
							Op.equalTo('sys.contentTypeId', 'weldasearch').weight(500),
							Op.in('contentType', ...['0/403/440', '0/403/439', '0/403/409', '0/403/408'])
						)
                    )
                ];
            }
        else if (search.searchType === 'media') {
            if (search.contentType) {
                return [Op.or().addRange([...MediaQueryBuilder(search.contentType)])];
            }
            else {
                return [
                    Op.or(
                        Op.equalTo('sys.contentTypeId', 'pressReleases'),
                        Op.equalTo('sys.contentTypeId', 'events'),
                        Op.equalTo('sys.contentTypeId', 'insights'),
                        Op.equalTo('sys.contentTypeId', 'ourStories'),
                        Op.equalTo('sys.contentTypeId', 'image'),
                        Op.startsWith('sys.uri', '/media-and-events/')
                    )
                ];
            }
        }
        else if (search.searchType === 'technical') {
            if (search.contentCategory) {
                //console.log("SEARCH - 154");
                return [
                    Op.or(
                        Op.and(
                            Op.equalTo('sys.contentTypeId', 'weldasearch').weight(500),
                            Op.in('contentType', ...search.contentCategory.split(','))
                        ),
                        Op.in('sys.metadata.contentCategory', ...search.contentCategory.split(','))
                    )
                ];
            }
            else {
                //console.log("SEARCH - 166");
                return [
                    Op.or(
                        Op.and(
                            Op.equalTo('sys.contentTypeId', 'weldasearch').weight(500),
                            Op.in('contentType', ...['0/403/440', '0/403/439', '0/403/409', '0/403/408'])
                        ),
                        Op.or(
                            Op.equalTo('sys.contentTypeId', 'pdf'),
                            Op.equalTo('sys.contentTypeId', 'word'),
                            Op.equalTo('sys.contentTypeId', 'excel'),
                            //TWI Research, TWI Knowledge, Non-TWI research, Non-TWI knowledge
                            Op.in('sys.metadata.contentCategory', ...['0/403/440', '0/403/439', '0/403/409', '0/403/408']),
                        )
                    )
                ];
            }
        }
    }
	//console.log("SEARCH - 183");
	return [
            Op.or(
                Op.equalTo('sys.dataFormat', 'webpage').weight(5000),
                Op.equalTo('sys.contentTypeId', 'weldasearch').weight(500),
                Op.equalTo('sys.contentTypeId', 'pressReleases').weight(5000),
                Op.equalTo('sys.contentTypeId', 'publishedPapers').weight(5000),
                Op.equalTo('sys.contentTypeId', 'events').weight(5000),
                Op.equalTo('sys.contentTypeId', 'insights').weight(5000),
		// Op.equalTo('sys.contentTypeId', 'staffProfiles').weight(5000),
                Op.equalTo('sys.contentTypeId', 'pdf').weight(5000),
                Op.equalTo('sys.contentTypeId', 'word').weight(5000),
                Op.equalTo('sys.contentTypeId', 'excel').weight(5000),
                //TWI Research, TWI Knowledge, Non-TWI research, Non-TWI knowledge
                Op.in('sys.metadata.contentCategory', ('0/403/440', '0/403/439', '0/403/409', '0/403/408')).weight(5000)
            )
	];
    }


export function filterUserGroupContent(settings) {
	if(settings.isAuth && settings.groups){
		if (settings.groups.includes("@Industrial Member")) {
			return[
				Op.or(
					Op.and(
						Op.equalTo("sys.metadata.permission", "OPEN"),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "IM")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "0/441/442")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "BOTH")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "0/441/444"))
					),
					Op.and(
					Op.equalTo("sys.metadata.permission", "PRO"),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "IM")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "0/441/442")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "BOTH")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "0/441/444"))
					),
					Op.equalTo("sys.metadata.permission", "IM"),
					Op.exists("sys.metadata.permission", false),
				)
				];
			} else if (settings.groups.includes("@Professional Member")) {
			return[
				Op.or(
					Op.and(
						Op.equalTo("sys.metadata.permission", "OPEN"),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "IM")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "0/441/442")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "BOTH")),
						Op.not(Op.equalTo("sys.metadata.linkedTo", "0/441/444"))
					),
					Op.equalTo("sys.metadata.permission", "PRO"),
					Op.exists("sys.metadata.permission", false),
				)
				];
		} else {
			return [Op.or(
				Op.equalTo("sys.metadata.permission", "OPEN"),
				Op.exists("sys.metadata.permission", false)
			)];
		}
	}
	else{
		return [Op.or(
			Op.equalTo("sys.metadata.permission", "OPEN"),
			Op.exists("sys.metadata.permission", false)
		)];
	}
}
export function listSearchType(search, listFilters) {
	if (listFilters) {
		let filterQueries = Object.keys(search)
		.filter(key => listFilters.indexOf(key) > -1 && search[key])
		.map(function(key, index) { 
			let query = Op.in(key); 
			query.values = search[key].split(',').map(id => id);
			if(search[key].toLowerCase() === 'all'){
				return [];
			}  
			return Op.or(Op.exists(key, false), query);
		});
		return filterQueries;
	}
}

export function taxonomyfilters(search, taxonomyFilters) {
	if (taxonomyFilters) {
		let filterQueries = Object.keys(search)
		.filter(key => taxonomyFilters.indexOf(key) > -1 && search[key])
		.map(function(key, index) { 
			let query = Op.in(key); 
			query.values = search[key].split(',').map(id => id);
			return query;
		});
		return filterQueries;
	}
}
export function filters(search, filters, filterType, categoryPickerTaxonomy) {
	if (filters) {
		let filterQueries = Object.keys(search)
		.filter(key => filters.indexOf(key) > -1 && search[key])
		.map(function(key, index) { 
			let query = Op.in(key); 
			query.values = search[key].split(',').map(id => id); 
			return query;
		});
		return filterQueries;
	}
}

export function checkboxFilters(search, checkboxFilters) {
	if (checkboxFilters) {
		let filterQueries = Object.keys(search)
		.filter(key => checkboxFilters.indexOf(key) > -1 && search[key])
		.map(key => Op.equalTo(key, true));
		return filterQueries;
	}
	return [];
}

export function textFilters(search, textFilters) {
	if (textFilters) {
		let tf = textFilters.map(x => x.Name);
		let fq = Object.keys(search).filter(key => tf.indexOf(key) > -1 && search[key])
		.map(key => Op.equalTo(key, search[key]));
		return fq;
	}
	return [];
}

export function newsDateFilters(year, month) {
	if (year) {
		let startDate, endDate;			
		if (month) {
			startDate = new Date(year, month - 1);
			endDate = new Date(year, month);
		}
		else {
			startDate = new Date(year, 0);
			endDate = new Date(year, 11, 31);
		}
		return [Op.between('publishDate', startDate, endDate)];		
	}
	return [];
}

export function standardDateFilters(year, month) {
	if (year) {
		let startDate, endDate;			
		if (month) {
			startDate = new Date(year, month - 1);
			endDate = new Date(year, month);
		}
		else {
			startDate = new Date(year, 0);
			endDate = new Date(year, 11, 31);
		}
		return [Op.between('sys.version.published', startDate, endDate)];		
	}
	return [];
}

export function publishDateFilters(year, month) {
	if (year) {
		let startDate, endDate;			
		if (month) {
			startDate = new Date(year, month - 1);
			endDate = new Date(year, month);
		}
		else {
			startDate = new Date(year, 0);
			endDate = new Date(year, 11, 31);
		}
		return [Op.between('publishDate', startDate, endDate)];		
	}
	return [];
}

export function pageName(pageName) {
	return [Op.equalTo('pageName', pageName)];
}

export function section(section) {	
	return [Op.equalTo('section', section)];
}


export function dateRangeFilter(from, to)
{	
	if (from && to) {
		return [Op.or(Op.lessThanOrEqualTo('eventDate.from', new Date(from)), Op.greaterThanOrEqualTo('eventDate.to', new Date(to)),
					Op.lessThanOrEqualTo('eventDate.from', new Date(to)), Op.greaterThanOrEqualTo('eventDate.from', new Date(from)))];
	}
	else if (from) {		
		return [Op.or(Op.lessThanOrEqualTo('eventDate.from', new Date(from)), Op.greaterThanOrEqualTo('eventDate.to', new Date(from)))];		
	}
	else if (to) {
		return [Op.lessThanOrEqualTo('eventDate.from', new Date(to)), Op.greaterThanOrEqualTo('eventDate.to', new Date(to))];
	}
	let currentDate = new Date();
	let startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
	return [Op.or(
				Op.and(
					Op.lessThanOrEqualTo('eventDate.from', startOfDay), 
					Op.greaterThanOrEqualTo('eventDate.to', startOfDay)
				), 
				Op.greaterThanOrEqualTo('eventDate.from', startOfDay)
			)];
}

export function isPublished() {
	let currentDate = new Date();
	return [Op.lessThanOrEqualTo('publishDate', new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 59))];
}

export function orderBy(name, direction, orderQuery) {
	switch (direction) {
		case 'asc':
			return orderQuery ? orderQuery.asc(name) : OrderBy.asc(name);
		default:
			return orderQuery ? orderQuery.desc(name) : OrderBy.desc(name);
	}
}

export function sortOrder(search){
	if (search.sort){
		switch (search.sort){
			case 'date':
				return OrderBy.desc('publishDate').desc('pageDate').desc('sys.metadata.pageDate').desc('sys.version.published');
			case 'dateAsc':
				return OrderBy.asc('publishDate').asc('pageDate').asc('sys.metadata.pageDate').asc('sys.version.published');
			case 'dateAnnounce':
				return OrderBy.desc('dateAnnounced');
			case 'dateAnnounceAsc':
				return OrderBy.asc('dateAnnounced');
			case 'sortNameDesc':
				return OrderBy.desc('sortCol');
			case 'sortNameAsc':
				return OrderBy.asc('sortCol');
			default:
			return [];
		}
	}
	return [];
}

export function range(value, minKey, maxKey) {
	if (value) {
		return([Op.lessThanOrEqualTo(minKey, value), Op.greaterThanOrEqualTo(maxKey, value)]);
	}
	return [];
}

export function startWith(value) {
	if (value) {
		if (value == '0-9') {
			return [Op.and().addRange([...aToZLetters()])]; // to do
		}
		else {
			return [Op.startsWith('title', value)];
		}		
	}
	return [];
}

function aToZLetters(){
	let letArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
	return letArr.map(letter => Op.not(Op.startsWith('title', letter)));
}
export function rangeSingle(key, value) {
	if (value) {
		return([Op.lessThanOrEqualTo(key, value)]);
	}
	return [];
}

export function pathStartsWith(path){
	return [Op.startsWith('sys.uri', path)];
	
}


export function filterBySection(sections) {
	return [Op.or().addRange([...filterSectionByPage(sections), ...filterSectionByContentType(sections)])];
}

function filterSectionByPage(sections) {
	if (sections) {		
		return sections.split(',').map(section => Op.startsWith('sys.uri', section));
	}
	return [];
}

function filterSectionByContentType(sections) {
	if (sections) {
		return sections.split(',').filter(section => SectionToContentTypeMap[section])
		.map(section => Op.equalTo('sys.contentTypeId', SectionToContentTypeMap[section]));
	}
	return [];
}

function MediaQueryBuilder(contentTypes){
	return contentTypes.split(',').map(
		(c) => {
			switch(c){
				case 'Images':
				return Op.equalTo('sys.dataFormat', 'image');
				case 'Videos':
				return Op.equalTo('sys.datFormat', 'video');
				default:
				return Op.equalTo('sys.contentTypeId', c.charAt(0).toLowerCase() + c.substr(1).replace(/\s/g,''));
			}
			}
		);
}

/* sw */

export function pageDateFilter(year, month)
{
		if (year) {
		let startDate, endDate;			
		if (month) {
			startDate = new Date(year, month - 1);
			endDate = new Date(year, month);
		}
		else {
			startDate = new Date(year, 0);
			endDate = new Date(year, 11, 31);
		}
		return [
			Op.or(
				Op.between('sys.metadata.pageDate', startDate, endDate),
				Op.between('pageDate', startDate, endDate)
			)
			
		];		
	}
	return [];

}

export function pageDateYearFilter(year)
{
		if (year) {
			return [
				Op.between('sys.metadata.pageDate', year, year)
				];
		}
		return [];
}

export function dateAnnouncedFilter(year, month)
{
		if (year) {
		let startDate, endDate;			
		if (month) {
			startDate = new Date(year, month - 1);
			endDate = new Date(year, month);
		}
		else {
			startDate = new Date(year, 0);
			endDate = new Date(year, 11, 31);
		}
		return [
			Op.between('dateAnnounced', startDate, endDate)
		];		
	}
	return [];

}

export function projectStatus(status) {
	if (status != null)
	{
		return [
			Op.equalTo('status', status)

		];

		
	} else {
		return [];
	}


}

export function excludeHomePage() {
	return [
		Op.not(
			Op.endsWith('sys.uri', 'home.aspx')
			)
	];


}

export function hideFromListingPage() {
	return [
		Op.not(
			Op.equalTo('sys.metadata.hideFromListingPage', 'true')
			)
		];
}




export function orPathEndsWith(path){
	return [
		Op.or(
			Op.endsWith('sys.uri', path),
			Op.equalTo('contentTypeId', 'publishedPapers')
			)
		];
}


export function getMicrositeNews(siteName) {
	return [
		Op.and(
			Op.equalTo('sys.contentTypeId', 'pressReleases'),
			Op.contains('whichWebsiteToDisplayOn', siteName),
			)
	];
}

export function getGenericInsights(siteName) {
	return [
		Op.and(
			Op.equalTo('sys.contentTypeId', 'Insights'),
			Op.contains('whichWebsiteToDisplayOn', siteName),
			)
	];
}

//Events switch
export function showEventOnCorporate(microSiteName) {
	if (microSiteName != null && microSiteName != '') {
		return [
			Op.and(
				Op.equalTo('sys.contentTypeId', 'events'),
				Op.contains('whichWebsiteToDisplayOn', microSiteName),
				)
		];

	} else
	return [
			Op.equalTo('boolean', 'true')
		];


	// if (microSiteName == null && microSiteName == '')
	// {
	// 	return [
	// 		Op.equalTo('boolean', 'true')
	
	// 	];
	// }

}

export function getMicrositeEvents(microSiteName) {
	if (microSiteName != null && microSiteName != '') {
		return [
			Op.and(
				Op.equalTo('sys.contentTypeId', 'events'),
				Op.contains('whichWebsiteToDisplayOn', microSiteName),
				)
		];

	} else

	return [];

}

export function getPrivateEvents(companyName) {
	if (companyName != null && companyName != '') {
		return [
			Op.or(
				Op.exists('privateEvent', 'false'),
				Op.contains('privateEvent', companyName),
				)
		];

	} else {
		return [
			Op.exists('privateEvent', 'false')
		];
	}

}

export function getShowcase(showcaseCollection) {
	return [
		Op.and(
			Op.equalTo('sys.contentTypeId', 'showcase'),
			Op.contains('collection', showcaseCollection),
			)
	];
}

export function getMicrositeInsights(siteName) {
	return [
		Op.and(
			Op.equalTo('sys.contentTypeId', 'insights'),
			Op.contains('whichWebsiteToDisplayOn', siteName),
			)
	];
}


//Press Releases switch
export function hideFromCorporate() {
	return [
		Op.or(
			Op.equalTo('hideFromCorporate', "false"),
			Op.exists('hideFromCorporate', "false")

		)

	];
}







export function notNSIRCVacancies() {
	return [
		Op.not(
			Op.contains('reference', "NSIRC")
		)

	];
}


export function NSIRCVacancies() {
	return [
		Op.contains('reference', "NSIRC")
	];
}


export function ourPeopleFilter() {
	return [
		Op.contains('collection', "Our People")
	];
}


export function nsircSearch(){
	return [
		Op.or(
			Op.and(
				Op.equalTo('sys.contentTypeId', 'nsircPageTemplateWebpage'),
				Op.equalTo('sys.metadata.includeInSearch', true),
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'pressReleases'),
				Op.in('whichWebsiteToDisplayOn', ...["NSIRC_insights","NSIRC_students", "NSIRC_dissertations", "NSIRC_theses", "NSIRC_publications", "NSIRC_news"]))

		),

		
	];

}

export function cswipSearch(){
	return [
		Op.or(
			Op.and(
				Op.equalTo('sys.contentTypeId', 'cswipPageTemplateWebpage'),
				Op.equalTo('sys.metadata.includeInSearch', true),
			),
			Op.and(
				Op.equalTo('sys.contentTypeId', 'pressReleases'),
				Op.contains('whichWebsiteToDisplayOn', 'CSWIP'))

		),

		
	];

}

export function FAQQuery(searchTerm, siteName)
{
		//tests
		//var path = "/technical-knowledge/faqs#/";
		//var path = 	"/technical-knowledge/faqs/home.aspx#/";
		//var path = 	"/locations/south-east-asia/faqs/home.aspx#/";

		var path = window.location.pathname;

		if (path.includes("FAQListerPageHTMLFile.html") && siteName == '')
		{
			path = "/technical-knowledge/faqs#/";
		}

		path = path.replace("/home.aspx", "");

		path = path.includes(".aspx") ? path = path.substring(0, path.lastIndexOf(".aspx")) : path;

		path = path.endsWith('#/') ? path = path.replace("#/", "") : path;

		if (siteName != '')
		{
			return [

				Op.and(				
					Op.equalTo('sys.contentTypeId', 'faqs'),
					Op.contains('whichWebsiteToDisplayOn.list', siteName)
					)				
		];
		}

		return [

			Op.or(
				Op.and(
					Op.startsWith('sys.uri', path),
					Op.equalTo('sys.dataFormat', 'webpage'),
					Op.not(
						Op.equalTo('sys.properties.filename', 'home.aspx'),
						Op.equalTo('sys.properties.filename', 'faqs.aspx')
						)
					)
				)
			];





}



export function certificationFilter(type, sitename, certificationFilter) {
	if (type == null && sitename != null && certificationFilter == 'showSearch' ) {
		return [
			Op.contains('whichWebsiteToDisplayOn.list', sitename)
		];
	}


	if (type != null && sitename != null && certificationFilter == 'showSearch')	
	{
		return [

			Op.and(				
				Op.contains('certificationType.name', type),
				Op.contains('whichWebsiteToDisplayOn.list', sitename)
				)	
		];

	}
	
	if (sitename != null && certificationFilter != 'showSearch')
	{
		return [

			Op.and(				
				Op.contains('whichWebsiteToDisplayOn.list', sitename),
				Op.contains('certificationType.name', certificationFilter)
				)	
		];
	}

	
	return [];
}


export function certifiedCompanyFilter(Type) {

	if (Type != null)	
	{
		return [
			Op.contains('companyCertificate.list', Type),

		];

	}	
	
	return [];
}


export function twiJobsFilters(_search) {
	if (_search != null)
	{
		var { jobType, workingHours, companyName, distance, lon, lat } = _search;
		const today = new Date();
		const future = new Date();
		future.setFullYear(future.getFullYear() + 100);

		// console.log("distance: " + distance);
		// console.log("lat: " + lat);
		// console.log("lon: " + lon);

		if (distance == undefined) {
			distance = 1;

		}


		const filters = [
			Op.equalTo('jobType', jobType || []),
			Op.equalTo('workingHours', workingHours || []),
			Op.equalTo('companyName1.entryTitle', companyName || []),
			Op.between('closingDate', today, future),
		];

		if (lat && lon) {
			filters.push(
				Op.distanceWithin("location", lat, lon, distance)
			);
		}

		// console.log("filters: ", filters);

		return filters;
	}
	else return [];
}

export function datePostedFilter(searchDatePosted)
{
	var today = new Date().toISOString();

	if (searchDatePosted != "" & searchDatePosted !== undefined)
	{
		return [
			Op.between('datePosted', searchDatePosted, today)
		]

	}
	else return [];


}

export function excludeFromSearch() {
	return [
		Op.not(
			Op.startsWith('sys.uri', '/microsites/twi-certification/pdf/company-certificates')
			),
		Op.not(
			Op.startsWith('sys.uri', '/test-pages/')
			)
	];
}


export function TAPsFilter(_search) {
	if (_search != null)
	{
		var { Topics, Industries } = _search;


		var industriesField = "multipleChoice";
		var topicsField = "multipleChoice1";


		const filters = [
			Op.equalTo(industriesField, Industries || []),
			Op.equalTo(topicsField, Topics || []),
		];
		return filters;
		}
	return [];


}


export function getVideos(siteName) {
	return [
		Op.and(
			Op.equalTo('sys.contentTypeId', 'videos'),
			Op.contains('whichWebsiteToDisplayOn', siteName),
			)
	];
}


export function getVirtualAcademy() {
	return [
		Op.and(
			Op.equalTo('sys.contentTypeId', 'VirtualAcademy'),
			)
	];
}




